import React, { useState } from "react";
import dropDownIcon from "../../../img/icons/dropdown-icon.svg";
import "./style.css";
import plusIcon from "../../../img/icons/plus-icon.svg";

/**
 * @name DropDown
 * @function
 * @description Displays DropDown
 * @returns {JSX}
 * @param {*} props
 */
const InputDropDown = (props) => {
  const [isOpen, setIsOpen] = useState(false);
  const [focusedIndex, setFocusedIndex] = useState(-1);
  const [selectedOption, setSelectedOption] = useState("");
  /**
   * options = [
      {
        title:'',
        id:""
      }
    ]
   */
  const [filteredOptions, setFilteredOptions] = useState(props.options);
  const options = filteredOptions ?? props.options ?? [];
  const [inputValue, setInputValue] = useState(props.dropDownDefaultText);

  /**
   * Handles the input change event.
   *
   * @param {Event} event - The input change event.
   */
  const handleInputChange = (event) => {
    const newSearchTerm = event.target.value;
    setInputValue(event.target.value);
    // Filter the dropdown options based on the search term
    const filtered = props.options.filter((option) =>
      option["title"].toLowerCase().includes(newSearchTerm.toLowerCase())
    );
    setFilteredOptions(filtered);
    if (!isOpen) {
      setIsOpen(true);
    }
  };

  /**
   * @name handleKeyPress
   * @function
   * @description Handles the keys arrows Up and Down, Focus, Enter and Escape for accessibility
   */

  const handleKeyPress = (e) => {
    switch (e.key) {
      case 'ArrowDown':
      case 'ArrowUp':
        e.preventDefault();
        const direction = e.key === 'ArrowDown' ? 1 : -1;
        const options = document.querySelectorAll('.dropdown-options li');
        let newIndex = focusedIndex + direction;
  
        if (newIndex < 0) {
          newIndex = options.length - 1;
        } else if (newIndex >= options.length) {
          newIndex = 0;
        }
  
        setFocusedIndex(newIndex);
        options[newIndex].focus();
        break;
  
      case 'Enter':
          setIsOpen(!isOpen)
        break;

        case 'Escape':
          setIsOpen(!isOpen)
        break;
      
  
      default:
        break;
    }
  };

  /**
   * Toggles the dropdown's open/close state.
   */
  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  /**
   * Handles the selection of an option from the dropdown.
   *
   * @param {Event} event - The selection event.
   * @param {string} option - The selected option.
   */
  const handleOptionSelect = (event, option) => {
    event.stopPropagation();
    setIsOpen(!isOpen);
    setInputValue(option);
    setSelectedOption(option);
    props.setProjectName(option);
  };

  return (
    <div className="custom-dropdown__myAnalog">
      <div
        className={
          !props.mobile
            ? "custom-dropdown__myAnalog__container"
            : "custom-dropdown__myAnalog__container-mobile"
        }
      >
        <div
          className="custom-dropdown__myAnalog-wrapper"
          onClick={toggleDropdown}
          onKeyDown={handleKeyPress}
          role="combobox"
        >
          <div className="custom-dropdown__myAnalog-header">
            <input
              type="text"
              value={inputValue}
              className={`dropdown-header__myAnalog__input ${
                isOpen ? "open" : ""
              }`}
              onChange={(e) => {
                handleInputChange(e);
                props.setProjectID("");
                props.setProjectName("");
                props.setAddToMyAnalogType(0);
              }}
              aria-autocomplete="list"
              role="combobox" tabIndex={0} aria-label={`${props.title}`} aria-expanded={isOpen} 
            />
            
            <span
              className={`dropdown-header__myAnalog__icon ${
                isOpen ? "open" : ""
              }`}
            >
              <img src={dropDownIcon} alt="Dropdown Icon" aria-hidden="true"/>
            </span>
          </div>

          {isOpen && (
            <ul className="dropdown-options">
              <li
                className="dropdown-options__option__myAnalog"
                onClick={(event) => {
                  handleOptionSelect(event, props.dropDownDefaultText);
                  props.setProjectID("");
                  props.setProjectName(props.dropDownDefaultText);
                  props.setAddToMyAnalogType(0);
                }}
                key={props.dropDownDefaultText}
                tabIndex={0}
              >
                <span className="body-small">{props.dropDownDefaultText}</span>
              </li>
              {options.map((option) => (
                <li
                  key={option["id"]}
                  className="dropdown-options__option__myAnalog"
                  onClick={(event) => {
                    handleOptionSelect(event, option["title"]);
                    props.setProjectID(option["id"]);
                    props.setProjectName(option["title"]);
                    props.setAddToMyAnalogType(1);
                  }}
                  tabIndex={0}
                >
                  <span className="body-small">{option["title"]}</span>
                </li>
              ))}
              <li
                key={props.newProjectText}
                onClick={(event) => {
                  handleOptionSelect(event, props.newProjectText);
                  props.setAddToMyAnalogType(2);
                  props.setProjectID("");
                }}
                className="dropdown-options__option__myAnalog"
                tabIndex={0}
              >
                <img src={plusIcon} alt="plus icon" width="24" height="24" aria-hidden="true"/>
                <span className="body-small">{props.newProjectText}</span>
              </li>
            </ul>
          )}
        </div>
      </div>
    </div>
  );
};

export default InputDropDown;